export { COOKIE_NAME, ONE_YEAR_MS } from "@shared/const";

// 本地登录路由（已替换 Manus OAuth）
export const getLoginUrl = () => "/login";
